;(function (angular, _) {
  'use strict'
  angular.module('kilo.common.filters')
    .filter('jsonNoPretty', JsonFilter)

  JsonFilter.$inject = [
    // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ]
  function JsonFilter (
    // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ) {
    return function (json) {
      return JSON.stringify(json, null, '\t')
    }
  }
})(window.angular, window._)
